import * as moment from 'moment';

export function filterTimeBetweenList(startTime: string, endTime: string, timeToFilter: string): boolean {
  const startTime24H = convertTo24HourFormat(startTime);
  const endTime24H = convertTo24HourFormat(endTime) === '00:00' ? '24:00' : convertTo24HourFormat(endTime);
  const timeToFilter24H = convertTo24HourFormat(timeToFilter);

  return startTime24H <= timeToFilter24H && timeToFilter24H <= endTime24H;
}

export function filterTimeBetweenValue(
  startTime: string,
  endTime: string,
  opensAtValue: string,
  closesAtValue: string
): boolean {
  const startTime24H = convertTo24HourFormat(startTime);
  const endTime24H = convertTo24HourFormat(endTime) === '00:00' ? '24:00' : convertTo24HourFormat(endTime);
  const opensAtTime24H = convertTo24HourFormat(opensAtValue);
  const closesAtTime24H = convertTo24HourFormat(closesAtValue);

  return (
    (opensAtTime24H >= startTime24H && opensAtTime24H <= endTime24H) ||
    (closesAtTime24H >= startTime24H && closesAtTime24H <= endTime24H) ||
    (opensAtTime24H <= startTime24H && closesAtTime24H >= endTime24H)
  );
}

export function convertTo24HourFormat(time: string): string {
  const momentFormat = time.includes(':') ? 'HH:mm:ss' : 'hhA';
  return moment(time, momentFormat).format('HH:mm');
}
